import React from 'react';
import PropTypes from 'prop-types';
import {Popover, Glyphicon} from 'react-bootstrap';
import ReactDOM from 'react-dom';
import {Notifications} from './../../../utilities/DictUtilities';
import * as EN from './entry/EntryComponents';
import * as LV from './loc-vars/LocVarComponents';
import * as SU from './subentries/SubentryComponents';
import * as SE from './senses/SenseComponents';
import * as TR from './translations/TranslationComponents';
import * as PH from './phrases/PhrasesComponents';
import * as RE from './references/ReferencesComponents';
import {
    addTab,
    getPage,
    setPage,
    resetPage,
    getLexemeOptions,
    createLexemeTreeViewById,
    rebuildLexemeVarLocTreeViewById,
    getLexemeProperties,
    getDictionaryProperties,
    resetLexemeStatus,
    getTabs,
    changeTab,
    isToponym,
    openPage, LexemePageContent, changeLangDescr
} from './../LexemePage';
import {performSearchByInitialState} from './../../../search/lib/search';
import {SCModalMessage, SCModalTopSpinner, SCToastNotification} from './../../../dict-components/components';
import {LexemeEditor} from './LexemeEditor';
import {addTranslation} from './senses/SenseAction';
import './LexemeEditor.css';
import {toast} from 'react-toastify';
import Dict from 'dict-lib';
import {LexemePageContext} from "../LexemePageContext";

import stylesSearchPage from './../../../_css/dictionary/searchPage.module.css';
import stylesLexemePage from './../../../_css/dictionary/lexemePage.module.css';
import stylesSCPopup from './../../../dict-components/popup/SCPopup.module.css';

import BUtils from './../../../utilities/BaseUtilities';
import LexemePage from "./../LexemePage";
import {LexemeTitle} from "../parts/01_Title/LexemeTitle";
import {LexemeData} from "../parts/02_Data/LexemeData";
import {LexemeSubentries} from "../parts/03_Subentries/LexemeSubentries";
import {LexemePolyrhematics} from "../parts/04_Polyrhematics/LexemePolyrhematics";
import {LexemeReferences} from "../parts/05_References/LexemeReferences";
import {AdministrationUtilities} from "../../../administration/AdministrationHelper";
import {LexemaPageContextProvider} from "../LexemePageContextProvider";
import {saveEntryForm} from "./entry/EntryActions";

export var LexemeUtilities = {
    callByClassName: function (path, classNames, rebuildTree) {
        //this.closeAfterSave(); da aggiungere solo dove sicuramente non si blocca. Era stato messo nelle
        // operazioni dove tooltip e popup si chiudevano in sequenza (ed era brutto a vedersi), ma non ricordo quali
        classNames.map(className => {
            var elements = [].slice.call(document.getElementsByClassName(className));
            elements.map(classElement => {
                classElement.className += " lexemePartSaving";
            });
        });

        const promise = Dict.call(path);

        promise.then(result => {
            this.manageResult(result, classNames);
            if (rebuildTree) {
                rebuildLexemeVarLocTreeViewById();
            }
        });

        return promise;
    },

    callSimple: function (path, msg, host) {
        var msgAsClass = msg.replace(/_/g, '-').toLowerCase();
        this.showModalSpinner(Dict.t(typeof msg === 'undefined' ? 'loading' : msg), msgAsClass);

        const promise = Dict.call(path, undefined, host);
        promise.then(result => {
            if (result.result === 'OK' || result.result === 'OK_DELETING') {
                this.closeAfterSave();
                if (Object.keys(result.message).length > 0)
                    LexemeUtilities.showToastNotification(result.message, 5000, 2000);
            } else {
                this.showModalMessage(result.result.toLowerCase(), result.message, 5000);
            }
        });

        return promise;
    },

    callResetLexemeStatus: function (path, msg) {
        msg = typeof msg === 'undefined' ? 'RECALCULATE_LEXEME_STATUS' : msg;

        return LexemeUtilities.callSimple(path, msg).then(result => {
            setTimeout(function () {
                resetLexemeStatus().then(result => {
                    setTimeout(function () {
                            LexemeUtilities.closeModalSpinner();
                            performSearchByInitialState();
                        },
                        500);
                });
            }, 0);
        });
    },

    performResetLexemeStatus: function () {
        return resetLexemeStatus().then(result => {
            setTimeout(function () {
                    LexemeUtilities.closeModalSpinner();
                    performSearchByInitialState();
                },
                500);
        });
    },

    callSpinner: function (path, msg) {
        this.showModalSpinner(Dict.t(typeof msg === 'undefined' ? 'loading' : msg), '');
        this.handleSaveWaiting();

        const promise = Dict.call(path);
        promise.then(result => {
            if (result.result !== 'OK') {
                if (result.abstract === 'conflict 409') {
                    this.callSystemError(path, result.message);
                } else
                    this.showModalMessage(result.result.toLowerCase(), result.message, 5000);
            } else {
                this.closeModalSpinner();
                this.closeAfterSave();
                this.setPage(result);
            }
            this.handleSaveFinish();
        });

        return promise;
    },

    foundExternalCreateEnvironment: function (host) {
        /*return document.getElementById('lexeme-navigator-page-container-READ_ONLY_EXTERNAL_CREATE') !== null;*/
        const serverUrl = BUtils.getServerUrl();
        return typeof host !== 'undefined' && serverUrl !== host;
    },

    resetExternal: function (id, result, host) {
        if (result.result === 'OK')
            this.closeModalSpinner();
        Dict.call('/page/getPage/' + id + '/null/null', {headers: {}}, host).then(result => {
            const StandAloneLexemePageConst = <LexemePageContent
                key={"key-lexeme-read-move-sense-" + id}
                host={host}
                page={result.page}
                pageStatus={'READ_ONLY_EXTERNAL_CREATE'}
                descrLanguage={result.descrLanguage/*JSON.parse(result.additionalInfos).descrLanguage*/}
                sharedOptions={result.sharedOptions}
                classType={'ENTRIES'}
                startItem={null}
                status={'SET_PAGE'}
                callBackSelectionHandler={(selectableItem) => this._callBackSelectionHandler(selectableItem)}/>;
            ReactDOM.render(StandAloneLexemePageConst, document.getElementById('lexeme-navigator-page-container-READ_ONLY_EXTERNAL_CREATE'));
            var popovers = document.getElementsByClassName('popover');

            for (var popover of popovers) {
                popover.remove();
            }

            var creatableActive = document.getElementsByClassName('lexCreatableActive');
            if (creatableActive.length > 0) {
                creatableActive[0].click();
            }

        });

    },

    call: function (path, resetTab) {
        this.handleSaveWaiting();

        const promise = Dict.call(path);
        promise.then(result => {
            if (result.result === 'OK_NO_SET_PAGE') {
            } else if (result.result !== 'OK') {
                if (result.abstract === 'conflict 409') {
                    this.callSystemError(path, result.message);
                } else
                    this.showModalMessage(result.result.toLowerCase(), result.message, 5000);
            } else {
                this.closeAfterSave();
                this.setPage(result, resetTab);
            }
        });

        return promise;
    },

    //TODO: accorpare
    callSystemError: function (path, message) {
        var page = getPage().page;
        this.call('/page/setSystemError/' + page.lexeme_properties.root_entry_id + '/' + path.split('/').slice(1, 3).join('^') + '/' + message + '/');
    },

    callBuilderError: function (id, message) {
        this.call('/page/setBuilderError/' + id + '/' + message.replace(/(\r\n|\n|\r)/gm, "") + '/');
    },

    callResetTabPages: function (path, callLexemeStatus) {
        LexemeUtilities.handleSaveWaiting();
        return this.call(path).then(() => {
            LexemeUtilities.handleSaveFinish();
            this.resetTabPages();
            /*if(typeof callLexemeStatus !== 'undefined' && callLexemeStatus) {
                this.performResetLexemeStatus();
            }*/
        })
    },

    callByClassNameResetTabPages: function (path, classNames, rebuildTree) {
        LexemeUtilities.handleSaveWaiting();
        return this.callByClassName(path, classNames, rebuildTree).then(() => {
            LexemeUtilities.handleSaveFinish();
            this.resetTabPages();
        })

    },

    callHighlight: function (path, prefix, callResetLexemeStatus) {
        this.call(path).then(result => {
            Notifications.closeModalSpinner();
            if (result.result === 'OK') {
                this.performHighlight(prefix, JSON.parse(result.additionalInfos).newId);
                if (typeof callResetLexemeStatus !== 'undefined' && callResetLexemeStatus) {
                    this.performResetLexemeStatus();
                }
            } else
                this.showModalMessage(result.result.toLowerCase(), result.message, 4000);
        })
    },

    callHighlightWithModalSpinner: function (path, msg, prefix, callResetLexemeStatus) {
        Notifications.showModalSpinner(msg);
        this.call(path).then(result => {
            Notifications.closeModalSpinner();
            if (result.result === 'OK') {
                this.performHighlight(prefix, JSON.parse(result.additionalInfos).newId);
                if (typeof callResetLexemeStatus !== 'undefined' && callResetLexemeStatus) {
                    this.performResetLexemeStatus();
                }
            } else
                this.showModalMessage(result.result.toLowerCase(), result.message, 4000);
        })
    },

    callMultipleHighlight: function (path, prefix) {
        this.call(path).then(result => {
            JSON.parse(result.additionalInfos).newIds.split('_').forEach((id) => {
                this.performHighlight(prefix, id);
            })
        })
    },

    performHighlight: function (prefix, id) {
        var element = document.getElementById(prefix + id);
        var elementToAdd;
        if (element.classList.contains('lexHighlightable')) {
            elementToAdd = element;
        } else {
            elementToAdd = element.getElementsByClassName('lexHighlightable')[0];
        }

        elementToAdd.classList.add('lexHighlightable--active');

        setTimeout(() => {
            elementToAdd.classList.remove('lexHighlightable--active');
        }, 5000);
    },

    callNoClose: function (path) {
        const promise = Dict.call(path);
        promise.then(result => {
            this.handleSaveFinish();
            if (result.result === 'OK') {
                this.setPage(result);
            } else {
                if (result.abstract === 'conflict 409') {
                    this.callSystemError(path, result.message);
                } else
                    this.showModalMessage(result.result.toLowerCase(), result.message, 5000);
            }
        });

        return promise;
    },

    closeAfterSave: function () {
        const popovers = document.getElementsByClassName('popover');
        if (popovers.length > 0) {
            const popover = document.getElementsByClassName('popover')[0];
            popover.style = "visibility:hidden";
        }

        const draggables = document.getElementsByClassName('react-draggable');
        if (draggables.length > 0) {
            const draggable = document.getElementsByClassName('react-draggable')[0];
            draggable.style = "visibility:hidden";
        }

        setTimeout(function () {
            const btPopups = document.getElementsByClassName(stylesSCPopup['bt-popup-close']);
            var timeOut = 0;
            if (btPopups.length > 0) {
                btPopups[0].click();
                timeOut = 50;
            }

            setTimeout(function () {
                const elems = document.getElementsByClassName('lexEditableActive');
                if (elems.length > 0)
                    elems[0].click();
            }, timeOut);
        }, 50);
    },

    resetPage(result) {
        //resetPage(getPage());
        setPage(state, result);
    },

    changeLangDescr(descrLanguage) {
        //changeLangDescr(descrLanguage);

        var state = getPage();
        var result = JSON.parse(JSON.stringify(getPage()));
        result.descrLanguage = descrLanguage;
        const btPopups = document.getElementsByClassName('editorButtonBarClose');
        var timeOut = 0;
        if (btPopups.length > 0) {
            btPopups[0].click();
            timeOut = 50;
        }

        setPage(state, result);

    },

    setPage(result, resetTab) {
        var state = getPage();

        var involvedIds = JSON.parse(result.additionalInfos) === null ? undefined : JSON.parse(result.additionalInfos).involvedLexemeIds;
        if (typeof involvedIds !== 'undefined') {
            this.resetTabInvolvedItems(state, involvedIds);
        }

        state.tabs[state.tabIndex].page = result.page;

        if (typeof resetTab !== 'undefined' && resetTab) {
            const id = parseInt(result.lexemePageAnalysis.id);
            state.id = id;
            state.tabs[state.tabIndex].id = id;
            state.tabs[state.tabIndex].entryForm = result.page.title.entry_form;
        }

        result.descrLanguage = state.descrLanguage;

        setPage(state, result);
        this.resetResultItem(result.page);

        if (!resetTab) {
            this.resetFrontendValidation(result.page.lexeme_properties.root_entry_id);
        }
    },

    resetFrontendValidation(entryId) {
        Dict.call('/page/runFrontendValidation/' + entryId + '/').then((result) => {
            console.log();
        });
    },

    resetTabInvolvedItems(state, involvedIds) {
        var split = involvedIds.split('_');
        state.tabs.forEach((item, index) => {
            if (split.includes(item.id + '')) {
                Dict.call('/page/getPage/' + item.id + '/' + item.language + '/' + item.dictionatyType).then((itemResult) => {
                    state.tabs[index].page = itemResult.page;
                    this.resetResultItem(itemResult.page);
                    /*const homographic = itemResult.page.title.homographic;
                    state.tabs[index].entryForm = state.tabs[index].page.entry_form + (homographic !== '0' ? ('-' + homographic) : '');*/
                });
            }
        });
    },

    //TODO: se fa ancora storie il resetLexemeStatus allora creare un getPageWithResetStatus e metterlo qui
    resetTabPages() {
        var state = getPage();
        state.tabs.forEach((item, index) => {
            Dict.call('/page/getPage/' + item.id + '/' + item.language + '/' + item.dictionatyType).then((itemResult) => {
                //Dict.call('/page/resetLexemeStatus/' + item.id + '/').then((itemResult) => {
                state.tabs[index].page = itemResult.page;
                if (state.tabIndex === index)
                    setPage(state, itemResult);
                if (index === state.tabs.length - 1)
                    LexemeUtilities.performResetLexemeStatus();
            });
        });
    },

    resetResultItem(page) {
        const rootEntryId = page.lexeme_properties.root_entry_id;
        var lexemeResult = document.getElementsByClassName("dict-rootentry-" + rootEntryId);
        var entryIdsToUpdate = '';
        var searchType = '';
        for (const lexemeResultElement of lexemeResult) {
            for (const classListElement of lexemeResultElement.classList) {
                if (classListElement.startsWith('search-type-')) {
                    searchType = classListElement.replace('search-type-', '');
                }
            }

            const entryId = lexemeResultElement.id.replace('dict-result-item-', '');
            if (entryId === rootEntryId) {
                var eleForm = document.getElementById('result-entryForm-' + rootEntryId);
                var eleAbstr = document.getElementById('dict-result-item-entryAbstr-' + rootEntryId);
                var eleHomo = document.getElementById('dict-result-item-sup-' + rootEntryId);
                if (eleForm.innerHTML !== page.lexeme_data.root_entry_form || eleAbstr.innerHTML !== page.entry_abstract || eleHomo.innerHTML !== (page.title.homographic + '')) {
                    eleForm.innerHTML = page.lexeme_data.root_entry_form;
                    if (!isToponym())
                        eleAbstr.innerHTML = page.entry_abstract;

                    eleHomo.classList.remove(...eleHomo.classList);
                    if (page.title.homographic > 0) {
                        eleHomo.classList.add(stylesSearchPage['dict-result-entry-descr-homo--true']);
                    } else {
                        eleHomo.classList.add(stylesSearchPage['dict-result-entry-descr-homo--false']);
                    }
                    eleHomo.innerHTML = page.title.homographic;

                    var parent = eleAbstr.parentElement;
                    parent.classList.add(stylesSearchPage['dict-result-item--modified']);
                    setTimeout(function () {
                        parent.classList.remove(stylesSearchPage['dict-result-item--modified']);
                    }, 3000);
                }
            } else {
                entryIdsToUpdate += entryId + "_";
            }
        }

        var eleTabForm = document.getElementById('tab-entryForm-' + rootEntryId);
        if (eleTabForm !== null) {
            if (page.title.homographic > 0) {
                eleTabForm.innerHTML = page.lexeme_data.root_entry_form + '-' + page.title.homographic;
            } else {
                eleTabForm.innerHTML = page.lexeme_data.root_entry_form;
            }
        }

        if (entryIdsToUpdate.length > 0) {
            entryIdsToUpdate = entryIdsToUpdate.substring(0, entryIdsToUpdate.length - 1);
            Dict.call('/service/search/updateResultEntryItems/' + entryIdsToUpdate + '/' + searchType).then(result => {
                for (const resultItem of result) {
                    var eleForm = document.getElementById('result-entryForm-' + resultItem.id);
                    var eleAbstr = document.getElementById('dict-result-item-entryAbstr-' + resultItem.id)
                    if (eleForm.innerHTML !== resultItem.entryForm || eleAbstr.innerHTML !== resultItem.entryAbstract) {
                        eleForm.innerHTML = resultItem.entryForm;
                        eleAbstr.innerHTML = resultItem.entryAbstract;

                        var parent = eleAbstr.parentElement;
                        parent.classList.add('modified');
                    }
                }

                setTimeout(function () {
                    for (const lexemeResultElement of lexemeResult) {
                        lexemeResultElement.classList.remove('modified');
                    }
                }, 3000);
            });
        }
    },

    manageResult: function (result, classNames) {
        var state = getPage();
        const isError = result.result === 'ERROR';

        if (!isError) {
            this.closeAfterSave();
        }
        setTimeout(() => {
            if (!isError)
                this.setPage(result);
            classNames.map(className => {
                var elements = [].slice.call(document.getElementsByClassName(className)); // [].slice.call crea un array di oggetti. Mentre getElements una htmlcollection, che però non consente l'iterazione .map
                elements.map(classElement => {
                    if (!isError)
                        classElement.className = className + " lexemePartReload";
                    setTimeout(() => {
                        classElement.className = className;
                    }, isError ? 0 : 2000);
                });
            });
        }, isError ? 0 : 200);


        if (result.result === 'OK') {
            this.closeAfterSave();
        } else {
            if (result.abstract === 'conflict 409') {
                this.callSystemError(path, result.message);
            } else
                this.showModalMessage(result.result.toLowerCase(), result.message, 5000);
        }
    },

    playSound: function (media) {
        const playPromise = media.play();
        playPromise.catch(() => {
            this.showErrorModalMessage('MEDIA_RESOURCE_NOT_FOUND', 1500);
        })
    },

    showHighlight: function (elemId, duration, timeout) {
        const elem = document.getElementById(elemId);
        var className = elem.className;

        setTimeout(function () {
            elem.className += " lexHighlightable--active";
            setTimeout(function () {
                elem.className = className
            }, duration);
        }, timeout);
    },

    // TODO: Spostare tutti gli show messaging su DictUtilities->Notifications

    showToastNotification: function (message, duration, timeout) {
        Notifications.showToastNotification(message, duration, timeout);
        /*setTimeout(function () {
            toast(<SCToastNotification text={message}/>, {
                autoClose: duration > 0 ? 50000 : false,
                hideProgressBar: true
            })
        }, timeout);*/
    },

    showErrorModalMessage: function (message, timeout) {
        if (message.length > 130) {
            message = message.substring(0, 129) + '...';
        }

        Notifications.showErrorModalMessage(message, timeout);
    },

    showWarningModalMessage: function (message, timeout) {
        Notifications.showWarningModalMessage(message, timeout);
    },

    showModalMessage: function (type, message, timeout) {
        Notifications.showModalMessage(type, message, timeout);
    },

    showModalSpinner: function (message, additionalClass) {
        Notifications.showModalSpinner(message, additionalClass);
        /*ReactDOM.render(<SCModalTopSpinner show={true} msg={message + '...'}
                                           additionalClass={additionalClass}/>, document.getElementById("dict-modal-container"));*/
    },

    closeModalSpinner: function () {
        Notifications.closeModalSpinner();
        /*ReactDOM.render(<SCModalTopSpinner show={false} msg={''}/>, document.getElementById("dict-modal-container"));*/
    },

    closeModalPoly: function () {
        setTimeout(function () {
            document.getElementsByClassName("modal-poly")[0].click();
        }, 100);
    },

    emptyLexemePage: function () {
        ReactDOM.unmountComponentAtNode(document.getElementById("lexeme-page-container"));
    },

    encodeUrl: function (str) {
        return escape(encodeURIComponent(str));
    },

    retrieveLexemeToolbar: function (type, item, context, additionalData) {
        if (type === ToolbarTypes.ENTRY) {
            additionalData.isPoly = false;
            return LexemeToolbars.entry(item, context, additionalData);
        } else if (type === ToolbarTypes.LOC_VARS)
            return LexemeToolbars.locVars(item, context, additionalData);
        else if (type === ToolbarTypes.SUBENTRIES)
            return LexemeToolbars.subentries(item, context, additionalData);
        else if (type === ToolbarTypes.SENSES)
            return LexemeToolbars.senses(item, context, additionalData);
        else if (type === ToolbarTypes.SEMANTIC_UNIT_REFERENCES)
            return LexemeToolbars.semantic_unit_references(item, additionalData);
        else if (type === ToolbarTypes.TRANSLATIONS)
            return LexemeToolbars.translations(item, additionalData);
        else if (type === ToolbarTypes.PHRASES)
            return LexemeToolbars.phrases(item, context, additionalData);
        else if (type === ToolbarTypes.REFERENCES)
            return LexemeToolbars.references(item, context, additionalData);
        else if (type === ToolbarTypes.POLYRHEMATIC) {
            additionalData.isPoly = true;
            return LexemeToolbars.polyrhematic(item, context, additionalData);
        }
    },

    retrieveTranslationButtons: function (item) {
        return LexemeToolbars.translatable(item);
    },

    resetTranslationSelectorPopovers: function () {
        var trSelectors = document.getElementsByClassName("translation_selector");
        var len = trSelectors.length;
        for (var i = 0; i < len; i++) {
            if (typeof trSelectors[i] !== 'undefined')
                trSelectors[i].parentNode.removeChild(trSelectors[i]);
        }
    },

    getTypeaheadItem: function (collection, selected) {
        if (typeof selected !== 'undefined') {
            var index = collection.map((item) => {
                return item.id
            }).indexOf(Number(selected.id));

            return collection.slice(index, index + 1);
        } else return "";
    },

    getTypeaheadItemById: function (collection, id) {
        if (typeof id !== 'undefined') {
            var index = collection.map((item) => {
                return item.id
            }).indexOf(id);

            return collection.slice(index, index + 1);
        } else return "";
    },

    getTypeaheadItemByLabel: function (collection, label) {
        if (typeof label !== 'undefined') {
            var index = collection.map((item) => {
                return item.label
            }).indexOf(label);

            return collection.slice(index, index + 1);
        } else return "";
    },

    getContext: function (component) {
        return component.context;
    },

    getPageStatus: function (component) {
        const pageStatus = this.getContext(component).pageStatus;
        return typeof pageStatus === 'undefined' ? 'ERROR' : pageStatus;
    },

    getDisplayContext: function (component) {
        const displayContext = this.getContext(component).displayContext;
        return typeof displayContext === 'undefined' ? 'ERROR' : displayContext;
    },

    isDisplayContextDictionarySearch: function (component) {
        return this.getDisplayContext(component) === 'DICTIONARY_SEARCH';
    },

    isDisplayContextDictionaryExport: function (component) {
        return this.getDisplayContext(component) === 'EXPORT';
    },

    isPageEditable: function (component) {
        return this.getPageStatus(component) === 'EDITABLE';
    },

    isPageExternalDictEditable: function (component) {
        return this.getPageStatus(component) === LexemeEditingLevel.EXTERNAL_DICTIONARY_ENTRY;
    },

    handleKeyUp(evt, enterCallback) {
        if (evt.keyCode === 13) {
            enterCallback();
        } else if (evt.keyCode === 27) {
            this.closeAfterSave();
        }
    },

    handleSaveWaiting() {
        const button = document.getElementsByClassName('lexemeButtonSave')[0];
        if (typeof button !== 'undefined') {
            button.classList.add('lexemeButtonSaveWait');
            button.classList.remove('lexemeButtonSave');
            //button.classList.remove('btn-default');
        }
    },

    handleSaveFinish() {
        const button = document.getElementsByClassName('lexemeButtonSaveWait')[0];
        if (typeof button !== 'undefined') {
            button.classList.add('lexemeButtonSave');
            button.classList.remove('lexemeButtonSaveWait');
        }
    },

    /*handleClickBCustomClass: function (component, item, className) {
        return this.handleClickByClassName(component, item, className);
    },*/

    handleClick: function (component, item, className) {

        const isReadOnly = this.isReadOnly(component);
        const isEditable = this.isPageEditable(component);
        const isExternalDictEditable = this.isPageExternalDictEditable(component);
        const isSelectable = this.isSelectable(component);
        const isTranslatable = this.isTranslatable(component);
        const isReadOnlyCreatable = this.isReadOnlyCreate(component);
        const isOpenable = this.isOpenable(component);

        if (isReadOnly && isOpenable) {
            Dict.call('/page/getLexemePageData/' + item.entry_id + '/' + null + '/').then(result => {
                LexemeUtilities.openLexemePage(result.id, result.rootEntryId, true, LexemeEditingLevel.READ_ONLY, result.entryForm, undefined, result.entryAbstr, result.language, result.languageCode, undefined);
            });
        } else if (isEditable || isSelectable || isReadOnlyCreatable || isTranslatable || isExternalDictEditable) {
            const active = document.getElementsByClassName(typeof className === 'undefined' ? this.getLexClass(component) + 'Active' : className);
            if (active.length > 0)
                active[0].click();


            if (isSelectable)
                component.context.selectionHandler({name: component.state.name, ids: item.ids});

            return item === component.state.item ? '' : item;
        } else return '';
        //return isEditable || isSelectable || isTranslatable ? (item == component.state.item ? '' : item) : "";
    },

    useEditor: function (pageStatus) {
        return pageStatus === LexemeEditingLevel.EDITABLE || pageStatus === LexemeEditingLevel.TRANSLATION_SELECTOR || pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE;
    },

    useTitleEditor: function (pageStatus) {
        return this.useEditor(pageStatus) || pageStatus === LexemeEditingLevel.EXTERNAL_DICTIONARY_ENTRY;
    },

    resetExternalPopovers(id) {
        var node = document.getElementById('lexeme-page-container').parentNode;
        var externalPopovers = document.querySelectorAll('body > .popover');
        if (externalPopovers.length > 0) {
            externalPopovers[0].remove();
        }

        setTimeout(function () {
            var buttonBar = document.getElementById(id); //document.querySelectorAll('body > ' + id);
            if (buttonBar !== null) {
                if (buttonBar.classList.contains('hidden-popover') || (buttonBar.classList.contains('fade') && !buttonBar.classList.contains('in'))) {
                    buttonBar.remove();
                } else {
                    var btOnNode = node.querySelector('#' + id);
                    if (btOnNode !== null)
                        btOnNode.id = btOnNode.id + '-2';

                    node.appendChild(buttonBar/*document.getElementById(id)*/);
                }
            }

            var popovers = document.getElementsByClassName('popover');

            for (var popover of popovers) {
                popover.style.setProperty("z-index", "1000000", "important");
            }
        }, 1000);
    },

    createButtonBarTooltip: function (component) {
        const name = component.state.name;
        const id = "lex-" + name.toLowerCase() + "-button-bar";
        const props = component.props;
        const item = component.state.item;
        const context = component.context;
        const pageStatus = context.pageStatus;
        const needsEditor = this.useEditor(pageStatus);
        const needsTitleEditor = this.useTitleEditor(pageStatus);

        if (pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE || this.foundExternalCreateEnvironment()) {
            this.resetExternalPopovers(id);
        }

        if ((!needsEditor && !needsTitleEditor) || (typeof component.state.item === 'undefined' ? false : Object.keys(component.state.item).length === 0)) {
            return this.getHiddenPopover(id);
        } else {
            const isPolyEdit = typeof props.isPolyEdit !== 'undefined' && props.isPolyEdit;
            const page = props.page;
            const polyEditClass = isPolyEdit ? " poly-edit " : "";

            if (name !== 'TITLE' && !needsEditor && needsTitleEditor) {
                return this.getHiddenPopover(id);
            }
            if (name === "TITLE") {
                return <Popover id={id} className={pageStatus.toLowerCase()}>
                    <LexemeEditor
                        name={name}
                        title={"Titiolo"}
                        type={ToolbarTypes.ENTRY} item={component.props.page} context={context}/></Popover>;
            } else if (name === "POLYRHEMATIC_TITLE") {
                return <Popover id="lex-poly-button-bar" className={pageStatus.toLowerCase()}><LexemeEditor
                    name={name}
                    title={"titolo"}
                    type={ToolbarTypes.POLYRHEMATIC}
                    item={this.isTranslationSelector(component) || this.isReadOnlyCreate(component) ? component.props : component.props.page}
                    context={context}
                    polyItem={item}/></Popover>
            } else if (name === "LOC_VARS") {
                var title = "";

                if (typeof item.id === 'undefined') {
                    var isFormBased = typeof item.form !== 'undefined';
                    title = isFormBased ? item.form : item.language;
                    var langs = "";
                    var sep = ",&nbsp;";
                    item.variants.map((itemLang) => langs += (isFormBased ? itemLang.language : itemLang.form) + sep);
                    title += "&nbsp;(" + langs.substring(0, langs.length - sep.length) + ")";
                } else {
                    title = item.form + "&nbsp;(" + item.language + ")";
                }

                title = (item.length > 0 && typeof item !== 'undefined' ? Dict.t(item) + ":&nbsp;" : "") + title;

                return <Popover id="lex-loc-var-button-bar">
                    <LexemeEditor
                        name={name}
                        title={title} type={ToolbarTypes.LOC_VARS}
                        item={item}
                        form={item.form}
                        context={context}/></Popover>;
            } else if (name === "SUBENTRY") {
                return <Popover id={id}
                                className={id + " " + polyEditClass + " " + pageStatus.toLowerCase()} /*positionLeft={400}*/>
                    <LexemeEditor
                        name={name}
                        title={item.cgr.description + " " + (typeof item.subentry_form === 'undefined' ? "" : item.subentry_form)}
                        type={ToolbarTypes.SUBENTRIES} item={item} isPolyEdit={isPolyEdit}
                        polyItem={isPolyEdit ? page : undefined}
                        form={""}
                        context={context}
                    />
                </Popover>
            } else if (name === "SENSE") {
                return <Popover id={id}
                                bsClass={polyEditClass + " underSuItem " + pageStatus.toLowerCase() + " popover"}>
                    <LexemeEditor
                        name={name}
                        title={item.description}
                        type={ToolbarTypes.SENSES} item={item} isPolyEdit={isPolyEdit}
                        polyItem={isPolyEdit ? props.polyItem : undefined}
                        form={""}
                        context={context}
                    />
                </Popover>;
            } else if (name === "PHRASE") {
                const phraseItem = item;
                const additionalData = {phraseItem, isSense: false};
                return <Popover id="lex-phrase-button-bar"
                                className={"popover" + " " + pageStatus.toLowerCase() + " "}
                                positionLeft={400}><LexemeEditor
                    name={name}
                    title={item.description}
                    type={ToolbarTypes.PHRASES}
                    item={component.state.sense}
                    additionalData={additionalData}
                    form={""}
                    context={context}
                /></Popover>;
            } else if (name === "TRANSLATION") {
                const suItem = component.props.suItem;
                const isSense = component.props.isSense;
                const id = item.id;
                const entry_id = item.entry_id;
                const isInverse = component.context.dictProperties.is_inverse;
                const additionalData = {suItem, isSense, id, entry_id, isInverse};

                return <Popover id="lex-tr-button-bar" bsClass={"popover"}
                                positionLeft={400}><LexemeEditor
                    name={name}
                    title={item.description}
                    type={ToolbarTypes.TRANSLATIONS}
                    item={item}
                    additionalData={additionalData}
                    form={""}
                    context={context}
                /></Popover>;
            } else if (name === "REFERENCE") {
                var direct = component.props.direct;
                const additionalData = {ids: item.ids, way: direct ? 'direct' : 'inverse', entry_id: item.entry_id};

                return <Popover id="lex-reference-button-bar" positionLeft={400}>
                    <LexemeEditor
                        name={name}
                        title={"sono baddi, proprio lui"}
                        type={ToolbarTypes.REFERENCES} item={item}
                        additionalData={additionalData}
                        isPolyEdit={component.props.isPolyEdit}
                        form={""}
                        context={context}
                    />
                </Popover>;
            } else if (name === "SEMANTIC_REFERENCE") {
                const additionalData = {ids: item.ids, way: props.way, entry_id: item.entry_id};

                return <Popover id="lex-semantic-unit-references-button-bar" bsClass={"popover"}
                                positionLeft={400}>
                    <LexemeEditor
                        name={name}
                        title={item.description}
                        type={ToolbarTypes.SEMANTIC_UNIT_REFERENCES}
                        item={item}
                        additionalData={additionalData}
                        form={""}
                        context={context}
                    /></Popover>;
            }
        }
    },

    getHiddenPopover: function (id) {
        return <Popover id={id} bsClass={'popover hidden-popover'}>&nbsp;</Popover>;
    },

    isSelectable: function (component) {
        const name = component.state.name;
        const status = component.context.pageStatus;

        if (name === "SUBENTRY") {
            return status === LexemeEditingLevel.SUBENTRY_SELECTOR;
        } else if (name === "SENSE") {
            return status === LexemeEditingLevel.SENSE_SELECTOR;
        } else if (name === "PHRASE") {
            return status === LexemeEditingLevel.PHRASE_SELECTOR
        } else
            return false;
    },

    isReadOnly: function (component) {
        const status = component.context.pageStatus;
        return status === LexemeEditingLevel.READ_ONLY;
    },

    isTranslationSelector: function (component) {
        return component.context.pageStatus === LexemeEditingLevel.TRANSLATION_SELECTOR;
    },

    isTranslatable: function (component) {
        return this.isTranslationSelector(component) && Object.values(TranslatableEntities).includes(component.state.name);
    },

    isCreatable: function (component) {
        return this.isReadOnlyCreate(component);
    },

    isReadOnlyCreate: function (component) {
        return component.context.pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE;
    },

    isExternalDict: function (component) {
        const status = component.context.pageStatus;
        return status === LexemeEditingLevel.EXTERNAL_DICTIONARY_ENTRY;
    },

    isOpenable: function (component) {
        return this.isReadOnly(component) && Object.values(OpenableEntities).includes(component.state.name);
    },

    getLexTextClass: function (component) {
        if (this.isPageEditable(component)) {
            return "lexTextEditable";
        } else
            return "lexTextOperationsDisabled";
    },

    getLexPolyOpenableClass: function (component) {
        if (!this.isReadOnly(component) && !this.isTranslationSelector(component)) {
            return "lexPolyOpenable";
        } else
            return "lexPolyOpenableDisabled";
    },

    getLexClass: function (component) {
        if (this.getDisplayContext(component) !== 'DICTIONARY_SEARCH' && this.getDisplayContext(component) !== 'EXPORT' && this.getDisplayContext(component) !== 'SINGLE_PAGE') {
            return "lexPlainText";
        } else if (this.isPageEditable(component)) {
            return "lexEditable";
        } else if (this.isSelectable(component)) {
            return "lexSelectable";
        } else if (this.isTranslatable(component)) {
            return "lexTranslatable";
        } else if (this.isCreatable(component)) {
            return "lexCreatable";
        } else if (this.isOpenable(component)) {
            return "lexOpenable";
        } else if (this.getDisplayContext(component) === 'EXPORT') {
            return "lexExportable";
        } else
            return "lexOperationsDisabled";
    },

    getLexLevelClass: function (component) {
        const state = component.state;

        if (state.name === 'TITLE' && component.context.pageStatus === LexemeEditingLevel.EXTERNAL_DICTIONARY_ENTRY) {
            return 'lexExternalDictionaryEntry';
        } else
            return '';
    },

    isActive: function (component, item, addSpecific) {
        const state = component.state;
        const classActive = LexemeUtilities.getLexClass(component) + "Active";
        const levelClassActive = typeof addSpecific !== 'undefined' && addSpecific ? LexemeUtilities.getLexLevelClass(component) + "Active" : '';

        if ((typeof state.item === 'undefined') && state.id === item)
            return classActive + ' ' + levelClassActive;
        else if ((typeof state.item !== 'undefined') && ((typeof state.item.ids !== 'undefined' && item.ids === state.item.ids) || (typeof state.item.id !== 'undefined' && item.id === state.item.id)))
            return classActive + ' ' + levelClassActive;
        else
            return "";
    },

    statusLowerThan(statusHigher, statusLower) {
        if (statusHigher === 'APPROVED')
            return statusLower === 'TO_REVISE' || statusLower === 'NOT_APPROVED' || statusLower === 'undefined';
        else if (statusHigher === 'TO_REVISE')
            return statusLower === 'NOT_APPROVED' || statusLower === 'undefined';
        else if (statusHigher === 'NOT_APPROVED')
            return statusLower === 'undefined';
        else
            return false;
    },

    openLexemePageByLexemeData(result, pageStatus, dictionaryType, callback) {
        this.openLexemePage(result.id, result.rootEntryId, true, pageStatus, result.entryForm, dictionaryType, result.abstr, result.language, result.languageCode, undefined, callback);
    },

    openLexemePage(id, rootEntryId, isUpToDate, pageStatus, entryForm, dictionaryType, entryAbstr, langId, langCode, displayContext, callback) {

        var elMenu = document.getElementsByClassName('editorButtonBarClose');
        if (elMenu.length > 0) {
            elMenu[0].click();
        }

        if (typeof callback === 'undefined')
            callback = () => {
            };

        var tabs = getTabs();

        if (tabs.length === 0) {
            const LexemePageConst = <LexemePage key={"key-lexeme-page-" + id}
                                                id={id} isUpToDate={isUpToDate}
                                                pageStatus={pageStatus}
                                                entryForm={entryForm}
                                                dictionaryType={dictionaryType}
                                                entryAbstr={entryAbstr}
                                                language={langId}
                                                languageCode={langCode}
                                                rootEntryId={rootEntryId}
                                                displayContext={displayContext}
                                                callbackParent={callback}
            />;
            ReactDOM.render(LexemePageConst, document.getElementById("lexeme-page-container"), () => {
                setTimeout(function () {
                    if (typeof callback === 'function')
                        callback();
                }.bind(this), 1000);
            });
        } else {
            var state = getPage();
            var newTab = {
                id: id,
                entryForm: entryForm,
                languageCode: langCode,
                language: langId,
                dictionaryType: dictionaryType,
                pageStatus,
                displayContext
            };

            var foundTab = state.tabs.findIndex((tab) => {
                return (newTab.id + '') === (tab.id + '') && newTab.entryForm === tab.entryForm && newTab.languageCode === tab.languageCode && newTab.dictionaryType === tab.dictionaryType;
            });

            var delay = 1000;
            if (foundTab > -1) {
                changeTab(state, foundTab);
                delay = 200;
            } else {
                state.tabs.push(newTab);

                state.isUpToDate = isUpToDate;
                state.tabIndex = state.tabs.length - 1;
                addTab(state, pageStatus);
            }

            setTimeout(function () {
                if (typeof callback === 'function')
                    callback();
            }.bind(this), delay);
        }
    },

    exportLexemePages(searchParams, totalPages, langId, dictionaryType, callback) {
        const groupLenght = 20;
        searchParams = JSON.parse(JSON.stringify(searchParams));
        searchParams.nPage = 1;

        /*//TODO: temporaneo
        if(typeof searchParams.forms[0].label !== 'undefined') {
            searchParams.forms[0] = searchParams.forms[0].label;
        }*/

        this.performExportLexemePages(searchParams, langId, dictionaryType, totalPages, [], [], (components, rawComponents) => {
            var groups = parseInt(components.length / groupLenght);
            if (groups === 0) {
                groups = 1;
            }
            var exportSplitContainer = document.createElement('span');
            exportSplitContainer.id = 'export-split-container';
            var exportSplitContainerStructure = document.createElement('span');
            exportSplitContainerStructure.id = 'export-split-container-structure';
            new Array(groups).fill().forEach((item, index) => {
                var part = components.slice(index * groupLenght, groupLenght * (index + 1));
                var div = document.createElement('div');
                div.id = 'export-split-part' + (index + 1);
                div.className = stylesSearchPage['export-split-part'] + ' export-split-part';
                ReactDOM.render(part, div);
                exportSplitContainer.appendChild(div);
            });

            var divStruct = document.createElement('div');
            divStruct.id = 'export-struct-split';
            divStruct.className = stylesSearchPage['export-struct-split-part'] + ' export-struct-split-part';
            ReactDOM.render(JSON.stringify(rawComponents), divStruct);
            exportSplitContainerStructure.appendChild(divStruct);

            document.getElementById("export-container").innerHTML = '';
            document.getElementById("export-container").appendChild(exportSplitContainer);
            document.getElementById("export-container").appendChild(exportSplitContainerStructure);

            //ReactDOM.render(components, document.getElementById("export-container"));

            callback();
        });
    },

    performExportLexemePages(searchParams, langId, dictionaryType, totalePages, components, rawComponents, callback) {
        var callSearch = typeof searchParams.forms[0].id !== 'undefined' ? 'service/searchById/' + searchParams.forms[0].id + '/' + searchParams.className + '/' : 'service/search/' + LexemeUtilities.encodeUrl(JSON.stringify(searchParams)) + '/';
        dictionaryType = typeof dictionaryType === 'undefined' ? 'null' : dictionaryType;
        const options = Dict.getLanguageOptionsById(langId);

        Dict.call(callSearch).then((result) => {
            var ids = [];

            for (const item of result.items) {
                ids.push(item.fields.id);
            }

            Dict.call('/page/getPages/' + LexemeUtilities.encodeUrl(JSON.stringify(ids)) + '/' + langId + '/' + dictionaryType).then((pages) => {
                document.getElementById('bt-search-export-counter').innerText = parseInt(searchParams.nPage * 100 / totalePages) + "%"; //searchParams.nPage + '/' + totalePages;
                var counter = ((searchParams.nPage - 1) * 8) + 1;

                for (const page of pages) {
                    page.lexeme_language_options = options;
                    components.push(this.exportPage(page, counter++));
                }

                rawComponents = rawComponents.concat(pages);

                if (searchParams.nPage === totalePages) {
                    callback(components, rawComponents);
                } else {
                    searchParams.nPage = searchParams.nPage + 1;
                    this.performExportLexemePages(searchParams, langId, dictionaryType, totalePages, components, rawComponents, callback);
                }
                //return {components, nPage: searchParams.nPage};
                //callback(componentoni, searchParams.nPage);
            });
        });
    },

    exportPage(page, idPostFix) {
        idPostFix = typeof idPostFix === 'undefined' ? 1 : idPostFix;
        var pageStatus = LexemeEditingLevel.READ_ONLY;
        var displayContext = LexemeDisplayContext.EXPORT;

        return this.getLexemePage(idPostFix, pageStatus, page, displayContext);
    },

    getLexemePage(idPostFix, pageStatus, page, displayContext, classType) {
        return <LexemaPageContextProvider idPostFix={idPostFix} pageStatus={pageStatus} page={page}
                                          classType={classType}
                                          displayContext={displayContext}/>
    },

    downloadTmpFile: function (filename) {
        var url = BUtils.getServerUrl() + '/service/io/downloadFile/' + filename;
        var a = document.createElement('a');
        a.href = url;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
    },

    downloadHtml: function (html, filename) {
        //var html = document.getElementById(containerId).innerHTML;
        var res = '';
        var css = document.getElementsByTagName('style');
        for (let styleItem of css) {
            res += styleItem.outerHTML;
        }

        html = '<html><head><meta charset="UTF-8">' + res + '</head>' + html + '</html>';

        Dict.call('/entry/retrieveMediaData', {
            method: 'POST',
            data: html,
            headers: {}
        }).then(function (result) {
            //var filename = result.filename;
            Dict.call('/service/io/createDownloadFile/' + result.filename + '/' + filename + '/html').then(result => {
                var url = BUtils.getServerUrl() + '/service/io/downloadFile/' + filename + '^dot^html';
                var a = document.createElement('a');
                a.href = url;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();

            });
        });
    },

    /**
     * Costruisce lo stesso HTML completo (con <style> inline) usato da downloadHtml, ma invece di
     * salvarlo come file .html lo invia al backend (/page/exportPdf/) che lo inoltra al microservizio
     * Node/Puppeteer per la conversione in PDF, e avvia il download del PDF risultante.
     *
     * Non usa Dict.call perche' serve una risposta binaria (blob): si usa fetch() nativo, replicando a
     * mano i due header che Dict.call imposta sempre (Authorization, X-Frontend-Request), puntando allo
     * stesso host (BUtils.getServerUrl() === Dict.getApiHost()).
     */
    downloadPdf: function (html, filename) {
        var res = '';
        var css = document.getElementsByTagName('style');
        for (let styleItem of css) {
            res += styleItem.outerHTML;
        }

        var fullHtml = '<html><head><meta charset="UTF-8">' + res + '</head>' + html + '</html>';

        var headers = {
            'Content-Type': 'text/plain;charset=UTF-8',
            'X-Frontend-Request': 'true'
        };
        if (localStorage.encode) {
            headers.Authorization = 'Basic ' + localStorage.encode;
        }

        fetch(BUtils.getServerUrl() + '/page/exportPdf/', {
            method: 'POST',
            headers: headers,
            body: fullHtml
        }).then(function (response) {
            //console.log('[downloadPdf] risposta ricevuta: status=' + response.status + ', content-type=' + response.headers.get('content-type') + ', content-length=' + response.headers.get('content-length'));
            if (!response.ok) {
                var err = new Error('Errore durante la generazione del PDF (status ' + response.status + ')');
                err.status = response.status;
                throw err;
            }
            return response.blob();
        }).then(function (blob) {
            //console.log('[downloadPdf] blob ricevuto: size=' + blob.size + ', type=' + blob.type);
            if (!blob || blob.size === 0) {
                throw new Error('PDF vuoto ricevuto dal server');
            }
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = filename + '.pdf';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
            //console.log('[downloadPdf] download avviato.');
        }).catch(function (error) {
            // Messaggio piu' specifico in base allo status HTTP, quando disponibile.
            // Usiamo "ignore:" per mostrare un testo letterale senza dover creare nuove chiavi i18n.
            var detail;
            if (error && error.status === 401) {
                detail = 'ignore:Errore PDF: chiave API non valida';
            } else if (error && error.status === 502) {
                detail = 'ignore:Errore PDF: servizio di generazione non raggiungibile';
            } else if (error && error.status === 504) {
                detail = 'ignore:Errore PDF: timeout durante la generazione';
            } else if (error && error.status) {
                detail = 'ignore:Errore PDF (status ' + error.status + ')';
            } else {
                detail = 'EXPORT_PDF_ERROR_MSG';
            }
            Notifications.showErrorModalMessage(detail, 4000);
            console.error('[downloadPdf] errore:', error);
        });
    },

    downloadJson: function (json, filename) {
        Dict.call('/entry/retrieveMediaData', {
            method: 'POST',
            data: json,
            headers: {}
        }).then(function (result) {
            Dict.call('/service/io/createDownloadFile/' + result.filename + '/' + filename + '/json').then(result => {
                var url = BUtils.getServerUrl() + '/service/io/downloadFile/' + filename + '^dot^json';
                var a = document.createElement('a');
                a.href = url;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();

            });
        });
    },

    getContextTypes: function () {
        return {
            pageStatus: React.PropTypes.string,
            selectSenseHandler: React.PropTypes.func
        };
    }
};

export var LexemePageInfos = {

    createContext: function (pageStatus, displayContext, page, callBackSelectionHandler, startItem, textToAdd, descrLanguage, classType, sharedOptions, host, module, singlePage) {
        const languageId = Object.keys(page).length > 0 ? page.lexeme_properties.language_id : "";
        const lexeme_options = page.lexeme_language_options;//Object.assign(page.lexeme_options, page.lexeme_language_options);
        const oppositeLanguages = page.lexeme_properties.opposite_language_codes; //typeof page.lexeme_options !== 'undefined' ? page.lexeme_properties.opposite_language_codes : AdministrationUtilities.getOppositeLanguages(languageId);
        const globalProperties = Dict.getGlobalProperties();
        descrLanguage = typeof descrLanguage !== 'undefined' ? descrLanguage : AdministrationUtilities.getDescriptionLanguage(languageId).code;

        return {
            pageStatus: pageStatus,
            displayContext: displayContext,
            properties: page.lexeme_properties,
            options: lexeme_options,
            dictProperties: page.dictionary_properties,
            data: page.lexeme_data,
            rootEntryId: Object.keys(page).length > 0 ? page.lexeme_properties.root_entry_id : "",
            languageId,
            module,
            host,
            oppositeLanguages,
            secondaryOut: Object.keys(page).length > 0 ? page.lexeme_properties.language_id : "",
            isTree: Object.keys(page).length > 0 ? page.lexeme_properties.is_tree_model + "" : "",
            selectionHandler: callBackSelectionHandler,
            startItem: typeof startItem !== 'undefined' && startItem != null ? JSON.stringify(startItem) : '',
            textToAdd,
            descrLanguage: descrLanguage,
            classType,
            sharedOptions,
            globalProperties,
            isExternalDict: page.isExternalDict,
            singlePage: singlePage
        }
    },

    getLexemeProperties: function (context, property) {
        return context.properties[property];
    },

    getLexemeOptions: function (context, option) {
        return context.options[option.toLowerCase()];
    },

    //lemmi
    isEntriesLexemeOptions(context, option) {
        return context.options['entries->' + option] === 'true';
    },

    //pagina di lavoro
    getEditPageManagerLexemeOptions(context, option) {
        return context.options['editPageManager->' + option];
    },

    isEditPageManagerLexemeOptions(context, option) {
        return context.options['editPageManager->' + option] === 'true';
    },

    getDictionaryProperties: function (context, property) {
        return context.dictProperties[property];
    },

    getRootEntryId: function (context) {
        return this.getLexemeProperties(context, "root_entry_id");
    },

    getLanguageId: function (context) {
        return this.getLexemeProperties(context, "language_id");
    },

    getDescriptionLanguage: function (context) {
        return this.getLexemeOptions(context, 'descr_language');
    },

    isLexeme: function (context) {
        return this.getLexemeProperties(context, 'lexeme');
    },

    isInverse: function (context) {
        return this.getDictionaryProperties(context, 'is_inverse');
    },

    isToponym: function (context) {
        return this.getLexemeProperties(context, 'discriminator') === 'TOPONYM';
    },

    isPureEncyclopedicByContext(context) {
        return context.globalProperties['DICTIONARY->ENCYCLOPEDIC_DICTIONARY_TYPE'] === 'PURE';
    },

};

export var LexemeReduxUtilities = {

    buildTabsUniqueLexemeId: function (state, index) {
        return state.tabs[index].id
    },


}

export const ToolbarTypes = {
    ENTRY: "ENTRY",
    LOC_VARS: "LOC_VARS",
    SUBENTRIES: "SUBENTRIES",
    SENSES: "SENSES",
    SEMANTIC_UNIT_REFERENCES: "SEMANTIC_UNIT_REFERENCES",
    TRANSLATIONS: "TRANSLATIONS",
    PHRASES: "PHRASES",
    REFERENCES: "REFERENCES",
    POLYRHEMATIC: "POLYRHEMATIC"
};

export const LexemeEditingLevel = {
    EDITABLE: "EDITABLE",
    READ_ONLY: "READ_ONLY", //Frontend
    LOGGED_READ_ONLY: "LOGGED_READ_ONLY", //Frontend
    READ_ONLY_CREATE: "READ_ONLY_CREATE",
    READ_ONLY_RENDERED: "READ_ONLY_RENDERED",
    TRANSLATING: "TRANSLATING",
    SUBENTRY_SELECTOR: "SUBENTRY_SELECTOR",
    SENSE_SELECTOR: "SENSE_SELECTOR",
    PHRASE_SELECTOR: "PHRASE_SELECTOR",
    TRANSLATION_SELECTOR: "TRANSLATION_SELECTOR",
    POLYRHEMATIC_SELECTOR: "POLYRHEMATIC_SELECTOR",
    FORM_SELECTOR: "FORMS_SELECTOR",
    EXTERNAL_DICTIONARY_SELECTOR: "EXTERNAL_DICTIONARY_SELECTOR",
    READ_ONLY_EXTERNAL_CREATE: "READ_ONLY_EXTERNAL_CREATE",
    EXTERNAL_DICTIONARY_ENTRY: "EXTERNAL_DICTIONARY_ENTRY",
};

export const LexemeDisplayContext = {
    DICTIONARY_SEARCH: "DICTIONARY_SEARCH",
    EXPORT: "EXPORT",
    PHRASE_SEARCH: "PHRASE_SEARCH",
    SINGLE_PAGE: "SINGLE_PAGE"
};

export const LexemeRenderStatus = {
    OPEN_PAGE: 'OPEN_PAGE',
    SET_PAGE: 'SET_PAGE',
    CHANGE_TAB: 'CHANGE_TAB',
    REMOVE_TAB: 'REMOVE_TAB'
};

export const LexemeStatusTypeSearchItemsArray = [
    {code: "ROOT_ENTRY", label: "ROOT_ENTRY"},
    {code: "ALL_ELEMENTS", label: "ALL_ELEMENTS"},
    {code: "AT_LEAST_ONE_ELEMENT", label: "AT_LEAST_ONE_ELEMENT"}
];


export const StatusType = {
    APPROVED: "APPROVED",
    TO_APPROVED_TO_REVISE: "TO_APPROVED_TO_REVISE",
    TO_REVISE: "TO_REVISE",
    TO_REVISE_NOT_APPROVED: "TO_REVISE_NOT_APPROVED",
    NOT_APPROVED: "NOT_APPROVED"
};

export const EditingStatusTypes = {
    ANY: {text: "ANY", glyphicon: "edit", bsStyle: "default"},
    EDITING: {text: "EDITING", glyphicon: "edit", bsStyle: "warning"},
    FIRST_APPROVAL: {text: "FIRST_APPROVAL", glyphicon: "unchecked", bsStyle: "info"},
    FINAL_APPROVAL: {text: "FINAL_APPROVAL", glyphicon: "check", bsStyle: "success"}
};

export const LanguageTypeAheadTypes = {
    ALL_LANGUAGES: "ALL_LANGUAGES",
    ROOT_LANGUAGES: "ROOT_LANGUAGES",
    TREE_LANGUAGE_HIERARCHY: "TREE_LANGUAGE_HIERARCHY"
};

export const TranslatableEntities = {
    TITLE: "TITLE",
    SUBENTRY: "SUBENTRY",
    SENSE: "SENSE",
    PHRASE: "PHRASE",
    POLYRHEMATICS: "POLYRHEMATICS",
    POLYRHEMATIC_TITLE: "POLYRHEMATIC_TITLE"
};

export const OpenableEntities = {
    REFERENCE: "REFERENCE",
    TRANSLATION: "TRANSLATION",
    SEMANTIC_REFERENCE: "SEMANTIC_REFERENCE"
}

export const SoundableEntities = {
    ROOT_ENTRY: "ROOT_ENTRY",
    LOC_VAR: "LOC_VAR",
    PHRASEOLOGY: "PHRASEOLOGY"
};

var LexemeToolbars = {

    isSingleLang: function (item) {
        return typeof item.id !== 'undefined' && typeof item.language !== 'undefined';
    },

    isGroupLang: function (item) {
        return typeof item.language !== 'undefined' && typeof item.id == 'undefined';
    },

    isSingleForm: function (item) {
        return typeof item.id !== 'undefined' && typeof item.form !== 'undefined';
    },

    isGroupForm: function (item) {
        return typeof item.form !== 'undefined' && !this.isSingleForm(item);
    },

    isGroupItem: function (item) {
        return this.isGroupLang(item) || this.isGroupForm(item);
    },

    isSingleFormMain: function (item) {
        return this.isSingleForm(item) && item.type === 'MAIN';
    },

    isSingleLangMain: function (item) {
        return this.isSingleLang(item) && item.type === 'MAIN';
    },

    isSingleFormAlternative: function (item) {
        return this.isSingleForm(item) && item.type !== 'MAIN';
    },

    isSingleLocVarItem: function (item) {
        return this.isSingleLang(item) || this.isSingleForm(item);
    },

    isSingleMainLocVarItem: function (item) {
        return (this.isSingleLang(item) || this.isSingleForm(item)) && item.type === 'MAIN';
    },

    getLocVarDeleteItem: function (item) {
        if (this.isGroupLang(item)) {
            return item.variants[0]
        } else if (this.isSingleLangMain) {
            return item;
        } else
            return null;
    },

    /*isLanguageGroupLocVarItem: function (item) {
     return this.isGroupLang(item) && typeof item.language !== 'undefined';
     },*/

    isTreeModel: function (additionalData) {
        return additionalData.is_tree_model;
    },

    checkChangeTypology: function (item) {
        return this.isSingleMainLocVarItem(item) && ((item.typology !== "LEXOTYPE" || getLexemeOptions("allow_lexo_root")) && (item.type === 'MAIN'));
    },

    retrieveAddPhraseHeight(context) {
        var height = 160;
        if (context.properties['lexeme']) {
            height = parseFloat(height) + 50;
        }
        if (context.properties['phrase_original_script']) {
            height = parseFloat(height) + 50;
        }
        if (context.properties['bibliographical_reference']) {
            height = parseFloat(height) + 90;
        }

        return height;
    },

    isPoly(additionalData) {
        return additionalData.isPolyEdit;
    },

    isDirect() {
        return !getDictionaryProperties("is_inverse");
    },

    isActiveByContext(context) {
        return context.pageStatus !== LexemeEditingLevel.TRANSLATION_SELECTOR && context.pageStatus !== LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE;
    },

    entry: function (item, context, additionalData) {
        const isPoly = this.isPoly(additionalData);
        const isTransSelector = context.pageStatus === LexemeEditingLevel.TRANSLATION_SELECTOR;
        const isExternalCreate = context.pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE;
        const isExternalDict = context.isExternalDict;
        if (isExternalCreate) {
            additionalData.textToAdd = context.textToAdd;
        }
        additionalData.soundType = SoundableEntities.ROOT_ENTRY;
        additionalData.language_id = context.languageId;
        additionalData.isExternalDict = isExternalDict;
        additionalData.host = context.host;

        const isActiveByContext = this.isActiveByContext(context);
        const allFormSize = item.lexeme_data.all_forms.length;
        const isTree = this.isTreeModel(additionalData);
        const isToponym = item.lexeme_properties.discriminator === 'TOPONYM';
        const activateExternalApis = Dict.getGlobalProperty('ACTIVATE_EXTERNAL_APIS') === 'true';
        const sortAlphabetic = (context.options['entries->LANGUAGE_POLIES_ALPHABETIC_ORDER']) === 'true';
        const sortCgrAlphabetic = (context.options['entries->CGR_ALPHABETIC_ORDER']) === 'true';
        const isEncyclopedic = AdministrationUtilities.isEncyclopedic();

        if (isExternalDict) {
            return [{
                operation: 'DISCONNECT_EXTERNAL_LEXEME',
                glyph: 'resize-full',
                component: <EN.EntryDelete item={item} additionalData={additionalData}/>,
                width: 700,
                height: 120,
                minHeight: 120,
                active: isActiveByContext,
                status: 'OK'
            }]
        } else {
            return [
                {
                    operation: 'EDIT_FORM',
                    glyph: 'edit',
                    component: <EN.EntryEditForm item={item} /*form={form}*//>,
                    width: 400,
                    height: 190,
                    minWidth: 400,
                    minHeight: 190,
                    active: isActiveByContext,
                    status: 'OK'
                },
                {
                    operation: 'ADD_ALTERNATIVE_FORM',
                    glyph: 'plus-sign',
                    component: <EN.EntryAddAltForm item={item}/>,
                    width: 600,
                    minWidth: 350,
                    height: 225,
                    minHeight: 225,
                    active: isActiveByContext,
                    status: 'OK'
                },
                {
                    operation: 'ADD_CGR',
                    glyph: 'th-list',
                    component: <EN.EntryAddSubentry item={item} additionalData={additionalData} context={context}/>,
                    width: this.isTreeModel(additionalData) && !isExternalCreate ? 800 : 500,
                    minWidth: this.isTreeModel(additionalData) && !isExternalCreate ? 800 : 500,
                    minHeight: this.isTreeModel(additionalData) && !isExternalCreate ? 770 : 400,
                    height: this.isTreeModel(additionalData) && !isExternalCreate ? 770 : 400,
                    x: isExternalCreate ? -797 : 70,
                    y: isExternalCreate ? -218 : this.isTreeModel(additionalData) ? -100 : 0,
                    active: !isToponym && !isEncyclopedic,
                    status: 'OK'
                },
                {
                    operation: 'ADD_POLY',
                    glyph: 'list',
                    component: <EN.EntryAddPoly item={item} additionalData={additionalData} context={context}/>,
                    width: isTree && !isExternalCreate ? 800 : 500,
                    minWidth: isTree ? 800 : 500,
                    minHeight: isTree && !isTransSelector && !isExternalCreate ? 400 : 300,
                    height: isTree && !isTransSelector && !isExternalCreate ? 750 : 300,
                    x: isExternalCreate ? -797 : 70,
                    y: isExternalCreate ? -218 : (isTree ? -100 : 0),
                    active: !isToponym,
                    status: 'OK'

                },
                {
                    operation: 'SORT',
                    glyph: 'sort',
                    component: <EN.EntrySort item={item} additionalData={additionalData} context={context}/>,
                    width: isPoly ? 800 : 850,
                    height: 570,
                    minWidth: isPoly ? 800 : 850,
                    minHeight: 570,
                    x: 300,
                    active: isActiveByContext && !(sortAlphabetic && sortCgrAlphabetic),
                    status: 'OK'
                },
                {
                    operation: 'ADVANCED_FIELDS',
                    glyph: 'list-alt',
                    component: <EN.EntryAdvancedFields item={item}/>,
                    width: 800,
                    height: 750,
                    minHeight: 750,
                    y: -100,
                    active: this.isActiveByContext(context),
                    status: 'OK'
                },
                {
                    operation: 'ADD_SOUND',
                    glyph: 'volume-up',
                    component: <EN.EntryAddSound item={item} additionalData={additionalData}/>,
                    width: 740,
                    height: 360,
                    minWidth: 740,
                    minHeight: 360,
                    active: isActiveByContext,
                    status: 'OK'
                },
                {
                    operation: 'DATING',
                    glyph: 'calendar',
                    component: <EN.EntryDating item={item}/>,
                    width: 860,
                    minWidth: 860,
                    height: 275,
                    minHeight: 275,
                    active: isActiveByContext,
                    status: 'OK'
                },
                {
                    operation: 'LINKS',
                    glyph: 'link',
                    component: <EN.EntryLinks item={item} additionalData={additionalData}/>,
                    width: 900,
                    minWidth: 900,
                    height: 225,
                    minHeight: 225,
                    active: isActiveByContext,
                    status: 'OK'
                },
                {
                    operation: 'TRANSFORM_TO_POLY',
                    glyph: 'text-size',
                    component: <EN.EntryTransformToPoly item={item} context={context}/>,
                    width: 1200,
                    height: 500,
                    minWidth: 1200,
                    minHeight: 450,
                    y: -150,
                    x: -600,
                    active: !isExternalCreate && !isTransSelector,
                    status: 'OK'
                },
                {
                    operation: 'SHOW_HIDE',
                    glyph: 'eye-open',
                    component: <EN.EntryShowHide item={item} additionalData={additionalData}/>,
                    width: 500,
                    height: 150,
                    minWidth: 500,
                    minHeight: 100,
                    active: this.isActiveByContext(context),
                    status: 'OK'
                },
                {
                    operation: 'REBUILD',
                    glyph: 'refresh',
                    component: <EN.EntryRebuild item={item} /*form={form}*//>,
                    width: 500,
                    height: 130,
                    minWidth: 450,
                    minHeight: 130,
                    active: isActiveByContext,
                    status: 'OK'
                },
                {
                    operation: 'SHOW_FRONTEND_PAGE',
                    glyph: 'sunglasses',
                    component: <EN.EntryShowFrontendPage item={item}/>,
                    width: 800,
                    height: 600,
                    minWidth: 800,
                    minHeight: 600,
                    y: -60,
                    x: 140,
                    active: isActiveByContext,
                    status: 'OK'
                },
                {
                    operation: 'EDITING_STATUS',
                    glyph: 'ok',
                    component: <EN.EntryEditingStatus item={item} additionalData={additionalData}/>,
                    width: 900,
                    height: 130,
                    minWidth: 900,
                    minHeight: 130,
                    active: isActiveByContext,
                    status: 'OK'
                },
                {
                    operation: 'MANAGE_ALTERNATIVE_FORMS',
                    glyph: 'equalizer',
                    component: <EN.EntryAltFormRemove item={item}/>,
                    width: 400,
                    minWidth: 400,
                    height: 275,
                    minHeight: 275,
                    active: isActiveByContext && allFormSize > 1 && !isToponym,
                    status: 'OK'
                },
                {
                    operation: 'ADD_LOC_VAR',
                    glyph: 'leaf',
                    component: <EN.EntryAddVarLoc item={item}/>,
                    width: 900,
                    minWidth: 900,
                    height: 550,
                    minHeight: 350,
                    active: isActiveByContext && isTree && !isToponym && !isEncyclopedic,
                    status: 'OK'

                },
                {
                    operation: 'SET_PLACE',
                    glyph: 'globe',
                    component: <EN.EntryAddPlace item={item}/>,
                    width: 400,
                    minWidth: 400,
                    height: 350,
                    minHeight: 350,
                    y: -100,
                    active: isToponym && this.isActiveByContext(context),
                    status: 'OK'
                },
                {
                    operation: 'CHANGE_TYPOLOGY',
                    glyph: 'certificate',
                    component: <EN.EntryChangeTypology item={item} context={context}/>,
                    width: 500,
                    minWidth: 500,
                    height: 160,
                    minHeight: 160,
                    x: 520,
                    y: 0,
                    active: isActiveByContext && isTree && !isToponym,
                    status: 'OK'
                },
                {
                    operation: 'EXTERNAL_DICTIONARY_COMPARE',
                    glyph: 'new-window',
                    component: <EN.EntryExternalDictionary item={item} context={context}
                                                           additionalData={additionalData}/>,
                    width: 950,
                    minWidth: 400,
                    height: 700,
                    minHeight: 700,
                    y: -200,
                    active: activateExternalApis && !isEncyclopedic,
                    status: 'OK'
                },
                {
                    operation: 'DELETE_ENTRY',
                    glyph: 'trash',
                    component: <EN.EntryDelete item={item} additionalData={additionalData}/>,
                    width: 600,
                    height: 120,
                    minHeight: 120,
                    active: isActiveByContext,
                    status: 'OK'
                }
            ]
        }
    },

    polyrhematic: function (item, context, additionalData) {
        additionalData.polyItem = item;
        additionalData.language_id = context.languageId;
        const descrLang = AdministrationUtilities.getDescriptionLanguageByContext(context);
        additionalData.descrLang = descrLang;
        var additionalDataExternalPoly = BUtils.cloneJson(additionalData);
        var externalPolyLinkActive = context.options['activeLinkBetweenEntriesType->EXTERNAL_POLY'] === 'true';
        var externalSense = null;
        const isExternalCreate = context.pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE;

        var externalTranslate = false;
        if (isExternalCreate) {
            externalSense = item.subentries.length > 0 && item.subentries[0].senses.length > 0 ? item.subentries[0].senses[0] : null;
            externalTranslate = !context.dictProperties.is_inverse || context.sharedOptions['ALLOW_REVERSE_TRANSLATION'] === 'true';
        }

        return [
            {
                operation: 'ADD_CGR',
                glyph: 'th-list',
                component: <EN.EntryAddSubentry item={item} additionalData={additionalData} context={context}/>,
                width: this.isTreeModel(additionalData) ? 800 : 500,
                minWidth: this.isTreeModel(additionalData) ? 800 : 500,
                minHeight: this.isTreeModel(additionalData) ? 770 : 300,
                height: this.isTreeModel(additionalData) ? 770 : 300,
                y: this.isTreeModel(additionalData) ? -100 : 0,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'SORT_CGRS',
                glyph: 'sort',
                component: <EN.EntrySort item={item} additionalData={additionalData}/>,
                width: 535,
                height: 370,
                minWidth: 535,
                minHeight: 370,
                x: -620,
                y: 65,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'ADD_SENSE',
                glyph: 'plus-sign',
                component: <SE.SenseAdd item={item.subentries.length > 0 ? item.subentries[0] : null}
                                        additionalData={{isNew: true}} context={context}/>,
                minHeight: this.isTreeModel(additionalData) && context.pageStatus !== LexemeEditingLevel.TRANSLATION_SELECTOR && !isExternalCreate ? 750 : 200,
                height: this.isTreeModel(additionalData) && context.pageStatus !== LexemeEditingLevel.TRANSLATION_SELECTOR && !isExternalCreate ? 750 : 200,
                minWidth: 800,
                width: 800,
                x: isExternalCreate ? -1126 : 70,
                y: isExternalCreate ? -76 : (this.isTreeModel(additionalData) ? -320 : 0),
                active: item.subentries.length > 0 && !this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'ADD_TRANSLATION',
                glyph: 'globe',
                component: <SE.SemanticUnitAddTranslation item={externalSense} context={context}/>,
                width: isExternalCreate ? 800 : 1080,
                minWidth: isExternalCreate ? 600 : 900,
                height: 650,
                minHeight: 300,
                y: isExternalCreate ? -540 : -450,
                x: isExternalCreate ? -1120 : 450,
                active: true,//externalTranslate && isExternalCreate && externalSense != null /*this.isActiveByContext(context)*/,
                status: 'OK'
            },
            {
                operation: 'NOTES',
                glyph: 'file',
                component: <EN.EntryNotes item={item} additionalData={additionalData}/>,
                width: 500,
                minWidth: 500,
                height: 500,
                minHeight: 100,
                x: -620,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'EXTERNAL_MONO',
                glyph: 'hand-left',
                component: <EN.EntryLinks item={item} onlyExternalPoly={true}
                                          additionalData={additionalDataExternalPoly}/>,
                width: 900,
                minWidth: 900,
                height: 225,
                minHeight: 225,
                x: -200,
                active: this.isActiveByContext(context) && externalPolyLinkActive,
                status: 'OK'
            },
            {
                operation: 'LINKS',
                glyph: 'link',
                component: <EN.EntryLinks item={item} additionalData={additionalData}/>,
                width: 900,
                minWidth: 900,
                height: 225,
                minHeight: 225,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'TRANSFORM_IN_PHRASE',
                glyph: 'retweet',
                component: <EN.EntryPolyTransformInPhrase item={item} additionalData={additionalData}/>,
                width: 900,
                minWidth: 900,
                height: 250,
                minHeight: 250,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'MOVE_POLY',
                glyph: 'export',
                component: <EN.EntryPolyMove item={item} additionalData={additionalData} isMove={true}/>,
                width: 900,
                minWidth: 900,
                height: 160,
                minHeight: 160,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'SHOW_HIDE',
                glyph: 'eye-open',
                component: <EN.EntryShowHide item={item} context={context} additionalData={additionalData}/>,
                width: 500,
                height: 150,
                minWidth: 450,
                minHeight: 100,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'DELETE_ENTRY',
                glyph: 'trash',
                component: <EN.EntryDelete item={item} additionalData={additionalData}/>,
                width: 800,
                height: 120,
                minHeight: 120,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            /*{
                operation: 'NO_NEED_FOR_SEE_ENTRY',
                glyph: 'hand-left',
                component: <EN.EntryNoNeedForSeeEntry item={item} additionalData={additionalData}/>,
                width: 500,
                height: 150,
                minWidth: 450,
                minHeight: 100,
                active: this.isActiveByContext(context),
                status: 'OK'
            },*/
        ]
    },
    locVars: function (item, context, additionalData) {
        additionalData.soundType = SoundableEntities.LOC_VAR;

        const isGroupItem = this.isGroupItem(item);
        const isGroupForm = this.isGroupForm(item);
        const isGroupLang = this.isGroupLang(item);
        const isSingleLocVarItem = this.isSingleLocVarItem(item);

        const hasAlternativeForms = isSingleLocVarItem && context.data.lexeme_locVars.find(locItem => {
            return locItem.language === item.language && locItem.variants.length > 1;
        });

        const openManageAltForms = isGroupLang && item.variants.length > 1;
        const isAlternativeForm = item.type === 'ALTERNATIVE';

        additionalData.isLocVar = true;

        return [
            {
                operation: this.isGroupLang(item) ? 'DELETE_LANGUAGE_VARS' : 'DELETE_LOC_VAR',
                glyph: 'trash',
                component: <LV.LocVarDelete item={this.getLocVarDeleteItem(item)} context={context}/>, //form={form}/>,
                width: 600,
                height: 400, //(item.type == "MAIN" ? -1 : 120),
                minHeight: 120,
                additionalPopupClass: 'additional-deleteLocVar',
                active: isGroupLang || (this.isSingleLangMain(item) && !hasAlternativeForms),
                status: 'OK'
            },
            {
                operation: 'REMOVE_FORM',
                glyph: 'remove',
                component: <LV.LocVarRemoveForm item={item} /*form={form}*//>,
                width: 600,
                height: 130,
                minHeight: 130,
                active: (isSingleLocVarItem || isGroupForm) && isAlternativeForm,
                status: 'OK'
            },
            {
                operation: 'MANAGE_ALTERNATIVE_FORMS',
                glyph: 'equalizer',
                component: <EN.EntryAltFormRemove item={item} additionalData={additionalData}/>,
                width: 400,
                minWidth: 400,
                height: 275,
                minHeight: 275,
                active: openManageAltForms,
                status: 'OK'
            },
            {
                operation: 'ADVANCED_FIELDS',
                glyph: 'list-alt',
                component: <LV.LocVarAdvancedFields item={item} /*form={form}*//>,
                width: 800,
                height: 750,
                minHeight: 750,
                y: -200,
                active: this.isSingleLocVarItem(item),
                status: 'OK'
            },
            {
                operation: 'ADD_SOUND',
                glyph: 'volume-up',
                component: <EN.EntryAddSound item={item} additionalData={additionalData}/>,
                width: 740,
                height: 360,
                minWidth: 740,
                minHeight: 360,
                active: this.isSingleLocVarItem(item) && this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'PROMOTE_LOC_VAR',
                component: <LV.LocVarPromoteToRootEntry item={item} /*form={form}*//>,
                glyph: 'circle-arrow-up',
                width: -1,
                height: 120,
                active: !isAlternativeForm && this.isSingleLang(item),
                status: 'OK'
            },
            {
                operation: 'CHANGE_TYPOLOGY',
                component: <EN.EntryChangeTypology item={item} context={context}/>,
                glyph: 'certificate',
                width: 650,
                minWidth: 500,
                height: 160,
                minHeight: 160,
                active: this.checkChangeTypology(item),
                status: 'OK'
            },
            {
                operation: 'SHOW_HIERARCHY',
                glyph: 'resize-full',
                component: <LV.LocVarHierarchy item={item} /*form={form}*//>,
                //width: -1,
                minHeight: 400,
                minWidth: 200,
                height: 600,
                width: 800,
                y: -200,
                active: this.isSingleLang(item),
                status: 'OK'
            },
            {
                operation: 'EDIT_FORM',
                glyph: 'edit',
                component: <LV.LocVarEditForm item={item} /*form={form}*//>,
                width: 500,
                height: 150,
                minWidth: 450,
                minHeight: 100,
                active: isSingleLocVarItem, //this.isTreeModel(additionalData) && !this.isSingleLang(item),
                status: 'OK'
            },
            {
                operation: 'ADD_LOC_VAR_FOR_THIS_FORM',
                glyph: 'plus-sign',
                component: <LV.LocVarAdd item={item} /*form={form}*//>,
                minHeight: 400,
                minWidth: 200,
                height: 600,
                width: 800,
                y: -200,
                active: isSingleLocVarItem,
                status: 'OK'
            },
            {
                operation: 'ADD_ALTERNATIVE_FORM',
                glyph: 'plus',
                component: <EN.EntryAddAltForm item={item}/>,
                width: 600,
                minWidth: 350,
                height: 175,
                minHeight: 175,
                active: isGroupLang,
                status: 'OK'
            }
            //TODO: questa pagina apre un lessema per le varloc che crea problemi con il lessema della root (da ripensare/rifare per bene con un context appropriato)
            /*{
                operation: 'INFO',
                glyph: 'info-sign',
                component: <LV.LocVarPage item={item} full={true}/>,
                width: 600,
                height: -1,
                minHeight: 90,
                active: this.isSingleLang(item),
                status: 'OK'
            }*/
        ]
    },

    subentries: function (item, context, additionalData) {
        const isPoly = this.isPoly(additionalData);
        const isExternalCreate = context.pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE;

        return [
            {
                operation: 'EDIT',
                glyph: 'edit',
                component: <SU.SubEdit item={item} additionalData={additionalData}/>,
                width: 500,
                minWidth: 500,
                height: 450,
                minHeight: 450,
                x: isPoly ? -680 : 215,
                y: isPoly ? 15 : -17,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'ADD_SENSE',
                glyph: 'plus-sign',
                component: <SE.SenseAdd item={item} additionalData={{
                    isNew: true,
                    textToAdd: isExternalCreate ? context.textToAdd : undefined
                }} context={context}/>,
                minHeight: this.isTreeModel(additionalData) && context.pageStatus !== LexemeEditingLevel.TRANSLATION_SELECTOR && !isExternalCreate ? 750 : 200,
                height: this.isTreeModel(additionalData) && context.pageStatus !== LexemeEditingLevel.TRANSLATION_SELECTOR && !isExternalCreate ? 750 : 200,
                minWidth: isExternalCreate ? 500 : 800,
                width: isExternalCreate ? 500 : 800,
                /*y: this.isTreeModel(additionalData) ? -320 : 0,*/
                x: isExternalCreate ? -662 : (isPoly ? -680 : 215),
                y: isExternalCreate ? -76 : (isPoly ? 15 : -17),
                active: true,
                status: 'OK'
            },
            {
                operation: 'SORT_SENSES',
                glyph: 'sort',
                component: <SU.SubSenseSort item={item} context={context} additionalData={additionalData}/>,
                width: isPoly ? 550 : 650,
                height: 500,
                minWidth: isPoly ? 550 : 650,
                minHeight: 500,
                x: isPoly ? -680 : 215,
                y: isPoly ? 15 : -17,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'FORMS',
                glyph: 'th',
                component: <SU.SubForms item={item} additionalData={additionalData} context={context}/>,
                width: 1300,
                minWidth: 500,
                height: 650,
                minHeight: 650,
                x: isPoly ? -680 : -19,
                y: -250,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'FORMS_TEMPLATE',
                glyph: 'list-alt',
                component: <SU.SubFormsTemplate item={item} additionalData={additionalData} context={context}/>,
                width: 1300,
                minWidth: 500,
                height: 650,
                minHeight: 650,
                x: isPoly ? -680 : -19,
                y: -250,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'DELETE',
                glyph: 'trash',
                component: <SU.SubDelete item={item} additionalData={additionalData}/>,
                width: 500,
                minWidth: 500,
                height: 125,
                minHeight: 110,
                x: isPoly ? -680 : 215,
                y: isPoly ? 15 : -17,
                active: this.isActiveByContext(context),
                status: 'OK'
            }
        ]
    },

    senses: function (item, context, additionalData) {
        const isPoly = this.isPoly(additionalData);
        additionalData.languageId = context.languageId;
        var foundSortableTr = false;
        for (var key in item.translations) {
            if (Object.keys(item.translations[key]).length > 1) {
                foundSortableTr = true;
                break;
            }
        }

        const isExternalCreate = context.pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE;
        const isEncyclopedic = AdministrationUtilities.isEncyclopedic();

        const allowReverse = context.sharedOptions['ALLOW_REVERSE_TRANSLATION'] === 'true';
        const isInverse = context.dictProperties.is_inverse;

        var topics = Dict.getVarious('topics');
        const hideSort = Object.keys(item.phraseologies).length === 1 && !foundSortableTr;

        return [
            {
                operation: 'ADD_TRANSLATION',
                glyph: 'globe',
                component: <SE.SemanticUnitAddTranslation item={item} context={context}/>,
                width: isExternalCreate ? 800 : 1080,
                minWidth: isExternalCreate ? 600 : 900,
                height: 650,
                minHeight: 300,
                y: isExternalCreate ? -410 : -250,
                x: isExternalCreate ? -920 : 450,
                active: context.pageStatus !== LexemeEditingLevel.TRANSLATION_SELECTOR && !isEncyclopedic && (!isInverse || allowReverse),
                status: 'OK'
            },
            {
                operation: 'ADD_PHRASE',
                glyph: 'th-list',
                component: <SE.SenseEditAddPhrase item={item} context={context}
                                                  additionalData={{textToAdd: isExternalCreate ? context.textToAdd : undefined}}/>,
                width: 680,
                minWidth: 680,
                height: this.retrieveAddPhraseHeight(context),
                minHeight: this.retrieveAddPhraseHeight(context),
                x: isExternalCreate ? -805 : 450,
                y: isExternalCreate ? -89 : 200,
                active: true,
                status: 'OK'
            },
            {
                operation: 'SENSE_LOC_VAR_ADD',
                glyph: 'plus-sign',
                component: <SE.SenseAdd item={item}/>,
                minHeight: 400,
                minWidth: 200,
                height: 750/*450*/,
                width: 800,
                y: -320/*-200*/,
                active: this.isActiveByContext(context) && this.isTreeModel(additionalData),
                status: 'OK'
            },
            {
                operation: 'SENSE_LOC_VAR_DELETE',
                glyph: 'minus-sign',
                component: <SE.SenseRemove item={item}/>,
                width: 450,
                minWidth: 450,
                height: 325,
                minHeight: 325,
                active: this.isActiveByContext(context) && this.isTreeModel(additionalData),
                status: 'OK'
            },
            {
                operation: 'SPREAD_TO_CHILDREN',
                glyph: 'circle-arrow-down',
                component: <SE.SenseSpread item={item}/>,
                minHeight: 300,
                minWidth: 850,
                height: 300,
                width: 850,
                y: -200,
                active: this.isActiveByContext(context) && this.isTreeModel(additionalData) && !this.isSingleLang(item),
                status: 'OK'
            },
            {
                operation: 'PROMOTE',
                glyph: 'circle-arrow-up',
                component: <SE.SensePromote item={item}/>,
                minHeight: 400,
                minWidth: 200,
                height: 600,
                width: 800,
                y: -200,
                active: this.isActiveByContext(context) && this.isTreeModel(additionalData) && !this.isSingleLang(item),
                status: 'OK'
            },
            {
                operation: 'SORT',
                glyph: 'sort',
                component: <SE.SenseSort item={item} additionalData={additionalData}/>,
                width: isPoly ? 535 : 835,
                height: isPoly ? 430 : 570,
                minWidth: isPoly ? 535 : 835,
                minHeight: isPoly ? 440 : 570,
                x: isPoly ? -600 : 660,
                y: isPoly ? -15 : -100,
                active: this.isActiveByContext(context) && !hideSort,
                status: 'OK'
            },
            {
                operation: 'NOTES',
                glyph: 'file',
                component: <SE.SenseNotes item={item}/>,
                width: 500,
                minWidth: 500,
                height: this.isTreeModel(item) ? 500 : 200,
                minHeight: 200,
                x: 660,
                y: -200,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'ENCYCLOPEDIC_INFOS',
                glyph: 'blackboard',
                component: <SE.SenseEncyclopedicInfos context={context} item={item}/>,
                width: 600,
                minWidth: 600,
                height: 650,
                minHeight: 650,
                x: 660,
                y: -400,
                active: !isEncyclopedic && this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'USAGES',
                glyph: 'wrench',
                component: <SE.SenseUsages item={item}/>,
                width: 800,
                minWidth: 800,
                height: 200,
                minHeight: 200,
                x: 660,
                y: -200,
                active: !isEncyclopedic && this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'LINKS',
                glyph: 'link',
                component: <SE.SenseLinks item={item}/>,
                width: 900,
                minWidth: 900,
                height: 275,
                minHeight: 275,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'DATING',
                glyph: 'calendar',
                component: <SE.SenseDating item={item}/>,
                width: 500,
                minWidth: 500,
                height: 175,
                minHeight: 175,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'ADD_IMAGE',
                glyph: 'picture',
                component: <SE.SenseAddImage item={item}/>,
                width: 1024,
                minWidth: 1024,
                height: 660,
                minHeight: 660,
                y: -300,
                x: 250,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'TOPICS',
                glyph: 'comment',
                component: <SE.SenseTopics item={item}/>,
                width: 500,
                minWidth: 500,
                height: 180,
                minHeight: 180,
                y: -100,
                x: 550,
                active: typeof topics !== 'undefined' && topics.topics.length > 0 && this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'MOVE',
                glyph: 'copy',
                component: <SE.SenseMove item={item} mantain={false} context={context}/>,
                width: 850,
                minWidth: 650,
                height: 650,
                minHeight: 300,
                y: -250,
                x: 550,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'COPY',
                glyph: 'duplicate',
                component: <SE.SenseMove item={item} mantain={true}/>,
                width: 850,
                minWidth: 650,
                height: 650,
                minHeight: 300,
                y: -250,
                x: 550,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'SHOW_HIDE',
                glyph: 'eye-open',
                component: <SE.SenseShowHide item={item}/>,
                width: 570,
                minWidth: 570,
                height: 140,
                minHeight: 140,
                active: this.isActiveByContext(context),
                status: 'OK',
            },
            {
                operation: 'DELETE',
                glyph: 'trash',
                component: <SE.SenseDelete item={item} isEncyclopedic={isEncyclopedic}/>,
                width: 650,
                minWidth: 650,
                height: 125,
                minHeight: 110,
                active: this.isActiveByContext(context),
                status: 'OK'
            }
        ]
    },

    semantic_unit_references: function (item, additionalData) {
        return [
            {
                operation: 'DELETE',
                glyph: 'trash',
                component: <SE.SenseDeleteLink item={item} additionalData={additionalData}/>,
                width: 550,
                minWidth: 550,
                height: 125,
                minHeight: 110,
                active: additionalData.way === 'direct',
                status: 'OK'
            },
            /*{
             operation: 'SHOW_HIDE',
             glyph: 'eye-open',
             component: <SE.SenseHideLink item={item}/>,
             width: 500,
             minWidth: 500,
             height: 250,
             minHeight: 110,
             active: true
             },*/
            {
                operation: 'OPEN_TAB',
                glyph: 'open',
                command: 'OPEN_TAB',
                width: 500,
                minWidth: 500,
                height: 250,
                minHeight: 110,
                active: true
            }
        ]
    },

    translations: function (item, additionalData) {
        var enableEdit = true;
        if (additionalData.isInverse && additionalData.suItem.discriminator === 'SENSE') {
            try {
                var tgItem = additionalData.suItem.translation_group.find((tgItem) => {
                    return tgItem.translations[0].id === item.id;
                });

                enableEdit = typeof tgItem !== 'undefined' && (tgItem === null || !tgItem.onlyView);
            } catch (e) {
            }
        }

        return [
            {
                operation: 'OPEN_TAB',
                glyph: 'open',
                /*component: <TR.TranslationShowHide item={item} additionalData={additionalData}/>,*/
                command: 'OPEN_TAB',
                width: 630,
                minWidth: 630,
                height: 130,
                minHeight: 130,
                active: true, /*additionalData.isSense,*/
                status: 'OK'
            },
            {
                operation: 'EXTENDED_VIEW',
                glyph: 'zoom-in',
                component: <TR.TranslationExtendedView item={item}/>,
                width: 800,
                minWidth: 800,
                height: 200,
                minHeight: 200,
                active: enableEdit,
                status: 'OK'
            },
            {
                operation: 'NOTES',
                glyph: 'file',
                component: <TR.TranslationNotes item={item} additionalData={additionalData}/>,
                width: 500,
                minWidth: 500,
                height: 180,
                minHeight: 180,
                active: enableEdit,
                status: 'OK'
            },
            {
                operation: 'FORCE_DEF_ABS',
                glyph: 'text-width',
                component: <TR.TranslationForceDefAbs item={item} additionalData={additionalData}/>,
                width: 630,
                minWidth: 630,
                height: 130,
                minHeight: 130,
                active: enableEdit,
                status: 'OK'
            },
            {
                operation: 'SHOW_HIDE',
                glyph: 'eye-open',
                component: <TR.TranslationShowHide item={item} additionalData={additionalData}/>,
                width: 630,
                minWidth: 630,
                height: 130,
                minHeight: 130,
                active: enableEdit,
                status: 'OK'
            },
            {
                operation: 'DELETE',
                glyph: 'trash',
                component: <TR.TranslationDelete item={item} additionalData={additionalData}/>,
                width: 600,
                minWidth: 600,
                height: 130,
                minHeight: 130,
                active: enableEdit,
                status: 'OK'
            }
        ]
    },

    phrases: function (item, context, additionalData) {
        additionalData.soundType = SoundableEntities.PHRASEOLOGY;
        const allowReverse = context.sharedOptions['ALLOW_REVERSE_TRANSLATION'] === 'true';
        const isInverse = context.dictProperties.is_inverse;

        const isExternalCreate = context.pageStatus === LexemeEditingLevel.READ_ONLY_EXTERNAL_CREATE;

        return [
            {
                operation: 'DELETE',
                glyph: 'trash',
                component: <PH.PhraseDelete item={item} additionalData={additionalData} isDetach={false}/>,
                width: 500,
                minWidth: 500,
                height: 130,
                minHeight: 130,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'EDIT',
                glyph: 'edit',
                component: <SE.SenseEditAddPhrase item={item} context={context} additionalData={additionalData}/>,
                width: 680,
                minWidth: 680,
                height: this.retrieveAddPhraseHeight(context),
                minHeight: this.retrieveAddPhraseHeight(context),
                y: -250,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'NOTES',
                glyph: 'file',
                component: <PH.PhraseNotes item={item} additionalData={additionalData} context={context}/>,
                width: 500,
                minWidth: 500,
                height: 190,
                minHeight: 190,
                x: 600,
                y: -250,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'ADD_SOUND',
                glyph: 'volume-up',
                component: <EN.EntryAddSound item={item} additionalData={additionalData}/>,
                width: 740,
                height: 360,
                minWidth: 740,
                minHeight: 360,
                y: -180,
                x: 380,
                active: this.isActiveByContext(context),
                status: 'NOT_FINISHED'
            },
            {
                operation: 'MOVE_PHRASE',
                glyph: 'export',
                component: <PH.PhraseAssign item={item} additionalData={additionalData} isMove={true}/>,
                width: 900,
                minWidth: 900,
                height: 600,
                minHeight: 600,
                x: 400,
                y: -280,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'ASSIGN_PHRASE',
                glyph: 'resize-small',
                component: <PH.PhraseAssign item={item} additionalData={additionalData} isMove={false}/>,
                width: 900,
                minWidth: 900,
                height: 600,
                minHeight: 600,
                x: 400,
                y: -280,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'DETACH_PHRASE',
                glyph: 'resize-full',
                component: <PH.PhraseDelete item={item} additionalData={additionalData} isDetach={true}/>,
                width: 900,
                minWidth: 900,
                height: 130,
                minHeight: 130,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'TRANSFORM_IN_POLY',
                glyph: 'retweet',
                component: <PH.PhraseTransformInPoly item={item} additionalData={additionalData}/>,
                width: 900,
                minWidth: 900,
                height: 130,
                minHeight: 130,
                active: this.isActiveByContext(context),
                status: 'OK'
            },
            {
                operation: 'ADD_TRANSLATION',
                glyph: 'globe',
                component: <SE.SemanticUnitAddTranslation item={item} additionalData={additionalData}
                                                          context={context}/>,
                width: isExternalCreate ? 800 : 900,
                minWidth: isExternalCreate ? 600 : 900,
                height: 650,
                minHeight: 300,
                y: isExternalCreate ? -410 : -250,
                x: isExternalCreate ? -920 : 450,
                active: context.pageStatus !== LexemeEditingLevel.TRANSLATION_SELECTOR && (!isInverse || allowReverse),
                status: 'OK'
            },
            {
                operation: 'SHOW_HIDE',
                glyph: 'eye-open',
                component: <PH.PhraseShowHide item={item} additionalData={additionalData}/>,
                width: 570,
                minWidth: 570,
                height: 140,
                minHeight: 140,
                active: this.isActiveByContext(context),
                status: 'OK',
            }
        ]
    },

    references: function (item, context, additionalData) {
        return [
            {
                operation: 'DELETE',
                glyph: 'trash',
                component: <RE.ReferenceDelete item={item} additionalData={additionalData}/>,
                width: 600,
                minWidth: 600,
                height: 130,
                minHeight: 130,
                active: true/*additionalData.way === 'direct'*/,
                status: 'OK'
            },
            {
                operation: 'OPEN_TAB',
                glyph: 'open',
                command: 'OPEN_TAB',
                width: 500,
                minWidth: 500,
                height: 250,
                minHeight: 110,
                active: true
            }
        ]
    },

    translatable: function (component) {

        return {
            operation: 'TRANSLATE',
            glyph: 'resize-small',
            startItem: component.props.context.startItem,
            arriveIds: component.props.item.ids,
            additionalOnClickScript: "",
            width: 600,
            minWidth: 600,
            height: 130,
            minHeight: 130,
            active: true,
            status: 'OK'
        }
    }
};

export function translate(context, arriveIds) {
    const start = context.startItem;
    if (typeof arriveIds !== 'undefined') {
        LexemeUtilities.resetTranslationSelectorPopovers();
        LexemeUtilities.showModalSpinner(Dict.t('SPINNER_MSG_TRANSLATING'), "modal-spinner-rebuild");

        var startId = typeof JSON.parse(start).discriminator === "undefined" || JSON.parse(start).discriminator === 'SENSE' ? 'ids' : 'id';

        addTranslation(JSON.parse(start)[startId], arriveIds, context).then(result => {
            LexemeUtilities.closeModalSpinner();
            LexemeUtilities.resetTranslationSelectorPopovers();
            const foundExternalCreateEnvironment = LexemeUtilities.foundExternalCreateEnvironment();
            if (!foundExternalCreateEnvironment) {
                if (result.result === 'OK') {
                    const trIdComponent = "translation-id-" + JSON.parse(result.additionalInfos).trId;
                    LexemeUtilities.showHighlight(trIdComponent, 6000, 500);
                    LexemeUtilities.showToastNotification(result.message, 10000, 1500);
                } else
                    LexemeUtilities.showErrorModalMessage(result.message, 5000);
            }
        });
    } else {
        LexemeUtilities.showErrorModalMessage("ignore:" + Dict.t('SEMANTIC_UNIT_TO_TRANSLATE_NOT_FOUND'), 5000);
    }
}